export default "__VITE_ASSET__Bk61Jn9z__"